var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies } from "~/core/decorator";
import { Emit, Prop } from "vue-property-decorator";
import LawsuitFollow from "./lawsuit-follow.vue";
import { lawsuitStatus } from "./lawsuit.config";
import { OutsourceLawsuitService } from "~/services/domain-service/outsource-lawsuit-manage-index.service";
var LawsuitKind = /** @class */ (function (_super) {
    __extends(LawsuitKind, _super);
    function LawsuitKind() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // 弹框控制
        _this.dialog = {
            isOpenLawsuitFollow: false
        };
        _this.model = {
            lwasuitKind: "LAWSUIT_RECORD"
        };
        _this.rules = {
            lwasuitKind: [{ required: true, message: "请选择诉讼类型" }]
        };
        return _this;
    }
    Object.defineProperty(LawsuitKind.prototype, "lawsuit", {
        get: function () {
            return {
                kind: this.model.lwasuitKind,
                status: lawsuitStatus.court
            };
        },
        enumerable: false,
        configurable: true
    });
    LawsuitKind.prototype.refreshData = function () { };
    LawsuitKind.prototype.close = function () { };
    /**
     * 下一步
     */
    LawsuitKind.prototype.next = function () {
        var _this = this;
        var form = this.$refs["lwasuit-kind"];
        form.validate(function (valid) {
            if (!valid)
                return;
            var params = { caseAssistId: _this.rowData.id, lawsuitFollowType: _this.model.lwasuitKind, };
            _this.outsourceLawsuitService.saveCourtInfo(params).subscribe(function () { return _this.dialog.isOpenLawsuitFollow = true; });
        });
    };
    __decorate([
        Dependencies(OutsourceLawsuitService)
    ], LawsuitKind.prototype, "outsourceLawsuitService", void 0);
    __decorate([
        Prop()
    ], LawsuitKind.prototype, "rowData", void 0);
    __decorate([
        Emit("refreshData")
    ], LawsuitKind.prototype, "refreshData", null);
    __decorate([
        Emit("close")
    ], LawsuitKind.prototype, "close", null);
    LawsuitKind = __decorate([
        Component({
            components: {
                LawsuitFollow: LawsuitFollow
            }
        })
    ], LawsuitKind);
    return LawsuitKind;
}(Vue));
export default LawsuitKind;
